import type React from 'react';

import { useFocusFallbackRef } from 'src/app/shared/hooks/focus';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	const ref = useFocusFallbackRef(({ container, focus }) => focus(container.querySelector('h1')));

	return (
		<div className="container" ref={ref}>
			<PageMeta />
			<PageHeading />
			<PageBody />
		</div>
	);
};
